export default "__VITE_ASSET__DXWJaNjc__"